import React from 'react';
import Text from 'components/core/Text';
import { MAX_SESSION_TAGS } from 'constants/ponder';
import { TagList, TagOption } from './styles';

export type SessionTag = { id: number; key: string; label: string };

export const toggleTag = (selectedIds: number[], tagId: number) => {
  if (selectedIds.includes(tagId)) return selectedIds.filter((id) => id !== tagId);
  return selectedIds.length < MAX_SESSION_TAGS ? [...selectedIds, tagId] : selectedIds;
};

type Props = {
  tags: SessionTag[];
  selectedIds: number[];
  onToggle: (tagId: number) => void;
};

const TagPicker = ({ tags, selectedIds, onToggle }: Props) => {
  const isFull = selectedIds.length >= MAX_SESSION_TAGS;

  return (
    <>
      <TagList role="group" aria-label="Session tags">
        {tags.map((tag) => {
          const isSelected = selectedIds.includes(tag.id);
          return (
            <TagOption
              key={tag.id}
              type="button"
              aria-pressed={isSelected}
              disabled={isFull && !isSelected}
              onClick={() => onToggle(tag.id)}
            >
              {tag.label}
            </TagOption>
          );
        })}
      </TagList>
      <Text variant="textSmall" color="gray" mt={3} aria-live="polite">
        {selectedIds.length} of {MAX_SESSION_TAGS} selected
      </Text>
    </>
  );
};

export default TagPicker;
